import Isotope from 'isotope-layout';

window.initIsotope = function () {
	const grid = document.querySelector('.js-masonry-layout');
	const iso = new Isotope(grid, {
		itemSelector: '.masonry-item',
		layoutMode: 'masonry',
		percentPosition: true,
		masonry: {
			columnWidth: '.column-1of4'
		}
	});

	setTimeout(() => {
		iso.layout();
	}, 100);
};
